import React, { FC } from 'react'

export const TimeOutIllustration: FC = () => (
  <svg
    width='178'
    height='137'
    viewBox='0 0 178 137'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M151.687 39.8514V135.966C151.687 136.483 151.14 137 150.592 137H12.642C12.0945 137 11.5471 136.483 11.5471 135.966V128.215H141.286C141.834 128.215 142.381 127.699 142.381 127.182V38.8179H150.592C151.14 38.8179 151.687 39.3347 151.687 39.8514Z'
      fill='#BEE7FD'
    />
    <path
      d='M142.746 27.2929H1.47705V127.541H142.746V27.2929Z'
      stroke='#394657'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M67.7651 69.563H17.7775C15.6041 69.563 13.9741 67.9373 13.9741 65.7698V59.8091C13.9741 57.6416 15.6041 56.0159 17.7775 56.0159H68.3084C70.4818 56.0159 72.1118 57.6416 72.1118 59.8091V65.7698C72.1118 67.9373 69.9384 69.563 67.7651 69.563Z'
      fill='#BEE7FD'
    />
    <path
      d='M126.989 91.2354H75.915C73.7416 91.2354 72.1116 89.6097 72.1116 87.4422V80.9397C72.1116 78.7721 73.7416 77.1465 75.915 77.1465H126.989C129.163 77.1465 130.793 78.7721 130.793 80.9397V86.9003C130.793 89.6098 129.163 91.2354 126.989 91.2354Z'
      fill='#BEE7FD'
    />
    <path
      d='M97.6494 115.078H46.5751C44.4018 115.078 42.7717 113.452 42.7717 111.285V105.324C42.7717 103.156 44.4018 101.531 46.5751 101.531H97.6494C99.8227 101.531 101.453 103.156 101.453 105.324V111.285C101.453 113.452 99.2794 115.078 97.6494 115.078Z'
      fill='#BEE7FD'
    />
    <path
      d='M1.47705 44.0934H142.203'
      stroke='#394657'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M29.188 17V27.2957'
      stroke='#394657'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M72.1118 17V27.2957'
      stroke='#394657'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M114.492 17V27.2957'
      stroke='#394657'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M143.5 62C161.184 62 175.523 47.6746 175.523 30C175.523 12.3254 161.184 -2 143.5 -2C125.816 -2 111.477 12.3254 111.477 30C111.477 47.6746 125.816 62 143.5 62Z'
      fill='#BEE7FD'
      stroke='white'
      strokeWidth='4'
    />
    <path
      d='M140.262 44.5336C139.658 44.5336 139.054 44.2594 138.615 43.8207L127.802 32.742C126.924 31.8097 126.924 30.3289 127.857 29.4514C128.735 28.519 130.217 28.519 131.096 29.4514L139.932 38.5556L155.794 16.1241C156.563 15.0821 157.99 14.8079 159.033 15.5757C160.076 16.3435 160.35 17.7695 159.582 18.8115L142.128 43.5464C141.744 44.0949 141.085 44.4788 140.426 44.5336C140.371 44.5336 140.316 44.5336 140.262 44.5336Z'
      fill='#33B888'
    />
  </svg>
)
